module.exports = __webpack_public_path__ + "static/media/LOADER_07.0697a445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_07.png
// module id = 315
// module chunks = 0